import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UTILS } from 'src/app/core/const/const';
import { Bien } from 'src/app/core/interfaces/bien';

@Component({
  selector: 'app-grid-biens',
  templateUrl: './grid-biens.component.html',
  styleUrls: ['./grid-biens.component.scss'],
})
export class GridBiensComponent {
  @Input() listeBiens: Partial<Bien>[] = [];
  @Input() btnAdmin = true;

  @Input() showActifPub: boolean = false;
  @Input() showIconFavorite: boolean = true;
  @Input() showIconOffre: boolean = false;
  @Input() showIconPartAcc: boolean = false;
  @Input() showIconVisite: boolean = false;
  @Input() showIconPrint: boolean = true;

  @Output() saveOrUpdateFromCardBien = new EventEmitter();

  constructor(private router: Router, private route: ActivatedRoute) {}

  doRefreshList(event: any) {
    this.saveOrUpdateFromCardBien.emit();
  }

  onBienClicked(bien: any) {
    let link =
      '/' +
      (bien.vente ? 'biens-a-vendre' : 'biens-a-louer') +
      '/' +
      UTILS.replaceSpace(bien.type) +
      '/' +
      UTILS.replaceSpace(bien.ville) +
      '/' +
      bien.property.pieces +
      (bien.property.pieces > 1 ? '-pieces/' : 'piece/') +
      bien.property.room +
      (bien.property.room > 1 ? '-chambres/' : '-chambre/') +
      bien.id;
    void this.router.navigate([link]);
  }
}
